<template>
  <v-dialog v-model="openMode" max-width="900px" persistent>
    <v-card class="edit-dialog">
      <v-card-title class="dialog-header">
        <v-icon left class="ml-2" dark>
          {{ formTitle === 'ערוך משתמש:' ? 'mdi-account-edit' : 'mdi-account-plus' }}
        </v-icon>
        {{ formTitle }}
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form @submit.prevent ref="form"> <!-- Login Details Section -->
            <v-card class="section-card mb-6" outlined>
              <v-card-title class="section-title">
                <v-icon color="#0d2c6d" class="ml-2">mdi-login</v-icon>
                פרטי התחברות
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-if="formTitle === 'ערוך משתמש:'" v-model="itemEdited.line_number" disabled outlined
                      dense type="number" hide-spin-buttons label="שם משתמש" class="input-field"
                      :rules="[v => !!v || 'שדה חובה']" required></v-text-field>
                    <v-text-field v-else v-model="itemEdited.line_number" outlined dense type="number" hide-spin-buttons
                      label="שם משתמש" class="input-field" :rules="[v => !!v || 'שדה חובה']" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-if="formTitle === 'ערוך משתמש:'" v-model="passObj.password" outlined dense
                      type="password" label="סיסמה" class="input-field"></v-text-field>
                    <v-text-field v-else v-model="itemEdited.password.hash" outlined dense type="password" label="סיסמה"
                      class="input-field" :rules="[v => !!v || 'שדה חובה']" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-if="formTitle === 'ערוך משתמש:'" v-model="passObj.repeat_password" outlined dense
                      type="password" label="אישור סיסמה" class="input-field"></v-text-field>
                    <v-text-field v-else v-model="itemEdited.repeat_password" outlined dense type="password"
                      label="אישור סיסמה" class="input-field" :rules="[v => !!v || 'שדה חובה']" required></v-text-field>
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field v-model="itemEdited.api_token" label="API טוקן" disabled outlined dense
                      hide-details="auto" class="mb-4" bg-color="grey lighten-4"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Phone Management Section -->
            <v-card class="section-card mb-6" outlined>
              <v-card-title class="section-title">
                <v-icon color="#0d2c6d" class="ml-2">mdi-phone-settings</v-icon>
                ניהול בטלפון
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="itemEdited.phone_password" outlined dense type="number" hide-spin-buttons
                      label="סיסמה לניהול" class="input-field" :rules="[v => !!v || 'שדה חובה']"
                      required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="itemEdited.owner_details.phone" outlined dense disabled
                      label="כניסה באמצעות זיהוי מספר" class="input-field"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Personal Details Section -->
            <v-card class="section-card mb-6" outlined>
              <v-card-title class="section-title">
                <v-icon color="#0d2c6d" class="ml-2">mdi-account-details</v-icon>
                פרטים אישיים
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="itemEdited.owner_details.name" outlined dense label="שם איש קשר"
                      class="input-field" :rules="[v => !!v || 'שדה חובה']" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="itemEdited.owner_details.business_name" outlined dense label="שם המוסד/ארגון"
                      class="input-field" :rules="[v => !!v || 'שדה חובה']" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-select :items="status" v-model="itemEdited.status" outlined dense label="מצב" class="input-field"
                      :rules="[v => !!v || 'שדה חובה']" required></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="itemEdited.owner_details.email" outlined dense label="דואר אלקטרוני"
                      class="input-field"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="itemEdited.owner_details.phone" outlined dense label="טלפון" type="number"
                      hide-spin-buttons class="input-field" :rules="[v => !!v || 'שדה חובה']" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="itemEdited.owner_details.business_id" outlined dense label="ת.ז/ח.פ"
                      class="input-field" :rules="[v => !!v || 'שדה חובה']" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="itemEdited.owner_details.address" outlined dense label="כתובת"
                      class="input-field"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Subscription Details Section -->
            <v-card class="section-card mb-6" outlined>
              <v-card-title class="section-title">
                <v-icon color="#0d2c6d" class="ml-2">mdi-package-variant</v-icon>
                פרטי מנוי
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-select :items="plans" :item-text="'name'" :item-value="'name'" v-model="selectedPlanName"
                      outlined dense label="חבילה" class="input-field"></v-select>
                  </v-col>
                  <v-col v-if="isTrialPlan" cols="12" sm="6"> <!-- רק לחבילת ניסיון -->
                    <v-text-field v-model="itemEdited.plan.trying_finish_date" outlined dense
                      label="תקופת ניסיון עד לתאריך" type="datetime-local" class="input-field"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Notes Section -->
            <v-card class="section-card" outlined>
              <v-card-title class="section-title">
                <v-icon color="#0d2c6d" class="ml-2">mdi-note-text</v-icon>
                הערות
              </v-card-title>
              <v-card-text>
                <v-textarea v-model="itemEdited.notes" rows="3" outlined dense label="הערות"
                  class="input-field"></v-textarea>
              </v-card-text>
            </v-card>
          </v-form>

          <v-row v-if="progressShow">
            <v-col class="d-flex justify-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="dialog-actions mb-2">
        <div>
          <v-btn v-if="formTitle === 'ערוך משתמש:'" color="secondary" class="action-button ml-2"
            @click="openPermissionsDialog()">
            <v-icon left>mdi-shield-account</v-icon>
            הרשאות
          </v-btn>
          <v-btn v-if="formTitle === 'ערוך משתמש:'" color="secondary" class="action-button" @click="openLinesDialog()">
            <v-icon left>mdi-phone-plus</v-icon>
            הוספת קווים
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="save-button ml-3"
          @click="formTitle === 'ערוך משתמש:' ? saveEditedIvr() : saveNewIVR()" :loading="progressShow"
          :disabled="progressShow">
          <v-icon left>mdi-content-save</v-icon>
          שמור
        </v-btn>
        <v-btn color="grey lighten-3" @click="openMode = false">
          ביטול
        </v-btn>
      </v-card-actions>
    </v-card>

    <AddLinesDialog v-model="addLinesDialog" v-if="addLinesDialog" :ivr="ivrToAddLines"></AddLinesDialog>

    <PermissionsDialog v-model="permissionsDialog" v-if="permissionsDialog" :ivr="ivrToChangePermission"
      :agentPermissions="agentPermissions" @ivrPermissionsChanged="ivrPermissionsChanged"></PermissionsDialog>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import AddLinesDialog from '@/components/agent/dialogs/AddLinesDialog'
import PermissionsDialog from '@/components/agent/dialogs/PermissionsDialog'
import SnackBar from '@/components/widgets/snackBar.vue'
import Util from '@/util/utils.js'


// תקופת ניסיון ריקה לא נשלחת לשרת: ביצירה השדה לא נוצר, ובעריכה הוא נמחק
// (editIvr מחליף את כל אובייקט plan במה שנשלח)
// keepTrial: רק בחבילת ניסיון. בכל חבילה אחרת התאריך לא נשלח, והשרת מוחק אותו
function withoutEmptyTrial(ivr, keepTrial = true) {
    const copy = JSON.parse(JSON.stringify(ivr));
    if (copy.plan && (!keepTrial || !copy.plan.trying_finish_date)) delete copy.plan.trying_finish_date;
    return copy;
}

export default {
  props: {
    itemToEdit: Object,
    formTitle: String,
    value: { type: Boolean, default: false },
  },
  components: {
    SnackBar,
    AddLinesDialog,
    PermissionsDialog
  },
  data: () => ({
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    ivrToAddLines: null,
    addLinesDialog: false,
    ivrToChangePermission: null,
    permissionsDialog: false,
    itemEdited: {
      owner_details: {
        phone: "",
        business_name: "",
        name: "",
        business_id: "",
        address: "",
      },
      plan: {
        plan_name: "",
        has_trying_period: false,
      },
      notes: "",
      password: {
        hash: "",
        salt: "",
      },
    },
    passObj: {
      password: "",
      repeat_password: "",
    },
    status: ["פעיל", "מושבת"],
    plans: [],
    agentPermissions: {},
  }),
  methods: {
    async saveNewIVR() {
      if (this.$refs.form.validate()) {
        if (this.itemEdited.password.hash) {
          if (this.itemEdited.password.hash !== this.itemEdited.repeat_password) {
            return this.showSnackBar("נא לאמת את הסיסמה החדשה", "red");
          }

          if (this.itemEdited.password.hash.length < 9 || this.itemEdited.password.hash.length > 20) {
            return this.showSnackBar("הסיסמה חייבת לכלול לפחות 9 תווים ולא יותר מ 20", "red");
          }
        }
        const ivrJSON = JSON.stringify({ ivr: withoutEmptyTrial(this.itemEdited, this.isTrialPlan) });
        this.progressShow = true;
        let token = localStorage.getItem("token");

        try {
          let api = process.env.VUE_APP_BASE_URL + "/agent_api/create_ivr";
          const res = await fetch(api, ApiServices.requestOptions("POST", ivrJSON, token));
          this.progressShow = false;
          const jsonObject = await res.json();
          if (res.status >= 400) {
            this.showSnackBar("Error: " + jsonObject, "red");
          } else if (res.status === 200) {
            this.$emit("ivrCreated", this.itemEdited, "המערכת נוצרה בהצלחה", "green");
            this.openMode = false;
          }
        } catch (error) {
          this.progressShow = false;
          this.showSnackBar("Error saved new contact: " + error, "red");
        }
      }
    },
    async saveEditedIvr() {
      if (this.$refs.form.validate()) {
        if (this.passObj.password) {
          if (this.passObj.password !== this.passObj.repeat_password) {
            return this.showSnackBar("נא לאמת את הסיסמה החדשה", "red");
          }

          if (this.passObj.password.length < 9 || this.passObj.password.length > 20) {
            return this.showSnackBar("הסיסמה חייבת לכלול לפחות 9 תווים ולא יותר מ 20", "red");
          }
        }

        const ivrJSON = JSON.stringify({ ivr: withoutEmptyTrial(this.itemEdited, this.isTrialPlan), passObj: this.passObj });
        this.progressShow = true;
        let token = localStorage.getItem("token");

        try {
          let api = process.env.VUE_APP_BASE_URL + "/agent_api/edit_ivr";
          const res = await fetch(api, ApiServices.requestOptions("PUT", ivrJSON, token));
          this.progressShow = false;
          const jsonObject = await res.json();
          if (res.status >= 400) {
            this.showSnackBar("Error: " + jsonObject, "red");
          } else if (res.status === 200) {
            this.$emit("ivrEdited", { ...this.itemEdited, status: this.itemEdited.status === "פעיל" }, "המערכת עודכנה בהצלחה", "green"); // לרשימה: true/false, לא הטקסט
            this.openMode = false;
          }
        } catch (error) {
          this.progressShow = false;
          this.showSnackBar("Error saved list: " + error, "red");
        }
      }
    },
    async getPlans() {
      try {
        let token = localStorage.getItem("token");
        let api = process.env.VUE_APP_BASE_URL + "/agent_api/get_plans";
        const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
        const jsonObject = await res.json();
        if (res.status >= 400) {
          this.showSnackBar("שגיאה בקבלת החבילות", "red");
        } else if (res.status === 200) {
          this.plans = jsonObject;
        }
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("שגיאה בקבלת החבילות: " + error, "red");
      }
    },
    openLinesDialog() {
      this.ivrToAddLines = this.itemEdited;
      this.addLinesDialog = true;
    },
    openPermissionsDialog() {
      this.ivrToChangePermission = this.itemEdited;
      this.permissionsDialog = true;
    },
    ivrPermissionsChanged(permissionsObj) {
      this.itemEdited.exten_permissions = permissionsObj;
      this.showSnackBar("ההרשאות עודכנו בהצלחה!", "green");
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },
    async getAgentPermissions() {
      try {
        const token = localStorage.getItem("token");
        const api = process.env.VUE_APP_BASE_URL + "/agent_api/get_agent_permissions";
        const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
        const json = await res.json();
        if (res.status === 200) {
          this.agentPermissions = json || {};
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
        // החבילה שנבחרה היא חבילת ניסיון - רק אז יש משמעות לתאריך סיום הניסיון
        isTrialPlan() {
            const planId = String((this.itemEdited.plan && (this.itemEdited.plan.plan_id && this.itemEdited.plan.plan_id._id || this.itemEdited.plan.plan_id)) || '');
            const plan = this.plans.find(p => String(p._id) === planId);
            return !!plan && plan.bill_type === 'trial';
        },
    openMode: {
      get() {
        return this.value;
      },
      set(v) {
        return this.$emit('input', v);
      }
    },
    selectedPlanName: {
      // השם לפי מזהה החבילה של המערכת. ברשימת המערכות plan_id מגיע כאובייקט החבילה המלא ($lookup),
      // ו-plan_name לא קיים במסד - ולכן קודם לא סומנה אף חבילה
      get() {
        const planId = String(this.itemEdited.plan?.plan_id?._id || this.itemEdited.plan?.plan_id || '');
        const plan = this.plans.find(p => String(p._id) === planId);
        return plan ? plan.name : this.itemEdited.plan?.plan_name;
      },
      set(value) {
        const selectedPlan = this.plans.find(plan => plan.name === value);
        if (selectedPlan) {
          this.itemEdited.plan.plan_id = selectedPlan._id;
        }
      }
    }
  },
  mounted() {
    if (this.formTitle === "ערוך משתמש:") {
      this.itemEdited = JSON.parse(JSON.stringify(this.itemToEdit));
      // plan_id מגיע מהרשימה כאובייקט החבילה המלא - בדיאלוג עובדים עם המזהה בלבד
      if (this.itemEdited.plan?.plan_id?._id) this.itemEdited.plan.plan_id = this.itemEdited.plan.plan_id._id;
      // רק אם יש תאריך: getFormatDate בלי ערך מחזירה את התאריך של עכשיו, והוא היה נשמר כתקופת ניסיון
      if (this.itemEdited.plan.trying_finish_date) this.itemEdited.plan.trying_finish_date = Util.getFormatDate(this.itemEdited.plan.trying_finish_date);
      // פעיל = true מהשרת, או הטקסט "פעיל" (אם הרשימה כבר עודכנה מעריכה קודמת). קודם: "פעיל" == true -> false,
      // ובעריכה השנייה של אותה מערכת בלי רענון - הדיאלוג הציג "מושבת", והשמירה השביתה את המערכת
      this.itemEdited.status = (this.itemEdited.status === true || this.itemEdited.status === "פעיל") ? "פעיל" : "מושבת";
      this.ivrToAddLines = JSON.parse(JSON.stringify(this.itemToEdit));
    }
    this.getPlans();
    this.getAgentPermissions();
  },
}
</script>

<style scoped>
.edit-dialog {
  border-radius: 12px;
  overflow: hidden;
  direction: rtl;
  font-family: 'Heebo', sans-serif;
}

.dialog-header {
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.section-card {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.section-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #0d2c6d;
  padding: 12px 16px;
  margin-bottom: 12px;
  background-color: rgba(13, 44, 109, 0.05);
}

.input-field {
  border-radius: 8px;
}

.dialog-actions {
  padding: 16px;
  display: flex;
  justify-content: space-between;
}

.save-button {
  background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%) !important;
  color: #0d2c6d !important;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.save-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.action-button {
  background: linear-gradient(135deg, #6a6aec 0%, #8a8aff 100%) !important;
  color: white !important;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .dialog-header {
    font-size: 1.25rem;
  }

  .section-title {
    font-size: 1rem;
  }
}

@media (max-width: 600px) {
  .dialog-actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .save-button,
  .action-button {
    margin-bottom: 8px;
    width: 100%;
  }

  .action-button {
    margin-right: 0 !important;
  }
}
</style>